module.exports = __webpack_public_path__ + "static/media/contactSeven.20dc6e48.jfif";